const { CDN_URL } = process.env.server

export const apiPath = lang => `/static/content/${lang}/interface`
export const staticPath = (lang, subDir) => `/static/content/${lang}/${subDir}`
export const cdnPathNotLocalized = subDir => `${CDN_URL}/${subDir}`
export const cdnPath = (lang, subDir) =>
  subDir ? `${CDN_URL}/${lang}/${subDir}` : `${CDN_URL}/${lang}`
